import '../../../static/fonts/upcli.ttf';
import './app.css'
import './mobile.css'
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { NavDropdown, MenuItem, Label, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Navbar from 'react-bootstrap/lib/Navbar';
import Nav from 'react-bootstrap/lib/Nav';
import NavItem from 'react-bootstrap/lib/NavItem';
import Helmet from 'react-helmet';
import { isLoaded as isAuthLoaded, load as loadAuth, logout } from 'redux/modules/auth';
import { ConsultMenu } from 'components';
import { routeActions } from 'react-router-redux';
import config from '../../config';
import { asyncConnect } from 'redux-connect';
import * as authActions from 'redux/modules/auth';
import Cookies from 'js-cookie';
import i18n from "i18next"
import Notice from './Notice'
import { translate } from 'react-i18next';
import PortalMenu from './PortalMenu';
import Footer from '../../components/common/Footer';
import { isMobile } from 'react-device-detect';
var MobileDetect = require('mobile-detect');
const styles = require('./App.scss');

@translate(['common'])
@asyncConnect([{
  promise: ({ store: { dispatch, getState }, params }) => {
    const promises = [];
    if (!isAuthLoaded(getState())) {
      promises.push(dispatch(loadAuth()));
    }
    return Promise.all(promises);
  }
}])
@connect(
  state => ({
    loggingIn:state.auth.loggingIn,
    user: state.auth.user,
    tokenExpired: state.auth.tokenExpired,
    loadError: state.errors.loadError,
    routeChanges: state.routing.location,
    anomalies: state.supervisionErrors.all,
    loadingBar:state.loadingBar,
  }),
  { logout, pushState: routeActions.push, ...authActions })

export default class App extends Component {

  state = {
    topStyles: { 
      position: 'fixed', right: '170px', 
      top: '20px', 
      fontSize: '20px',
    },
    width: undefined, height: undefined
  }

  componentDidUpdate(prevProps) {
    if (this.props.tokenExpired && !this.SessionExpired) {
      this.SessionExpired = true;
      clearInterval(this.interval)
      this.props.pushState('/sessionExpired');
    }

    if (!prevProps.user && this.props.user) {

      socket.emit('loggingSuccess', {
        ...this.props.user
      });

      if (this.props.user.role.indexOf('user') > -1) {
        this.props.pushState('/home');
      } else if (this.props.user.role == 'admin') {
        this.props.pushState('/admin/clientList');
      } else if (this.props.user.role.indexOf('client') > -1 || this.props.user.role == 'demo') {
        this.props.pushState('/home');
      } else if (this.props.user.role == 'commercial') {
        this.props.pushState('/commercial/clients');
      }
    }
    else if (prevProps.user && !this.props.user) {
      this.props.pushState('/logout');
    }

  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleLogout = (event) => {
    event.preventDefault();
    this.props.dispatch(authActions.logout('Vous êtes bien deconnecté')).then(() => this.props.pushState('/'));
  };

  handleResize = () => {
    this.setState({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  }

  componentDidMount() {
    socket.on('disconnected', () => {
      this.props.dispatch(authActions.logout('Vous êtes deconnecté'))
    });

    window.addEventListener('resize', this.handleResize);
    this.handleResize();

    if (window) {
      var md = new MobileDetect(window.navigator.userAgent);
      if (md.tablet() || md.phone()) {
        var topStyles = { position: 'fixed', right: '100px', top: '9px', fontSize: '20px' }
        this.setState({ topStyles })
      }

      const params = new URLSearchParams(window.location.search);
      let lang = params.get('l')

      if (lang) {
        i18n.changeLanguage(lang)
        Cookies.set('lang', params.l)
      }      
    }

  }

  render() {

    var logo = require('../Home/picto_asm_sts.png')

    const { width } = this.state
    const isSmallScreen = width ? width <= 768 : isMobile
    const { t, loggingIn, user } = this.props    


    const tooltip1 = (
      <Tooltip style={{ marginTop: '15px' }}>
        <strong>
          {t("main.deconnexion")}                
        </strong>
      </Tooltip>
    );

    var langChooser = (      
      <Nav className="lang-chooser" pullRight>
        <NavDropdown eventKey={22} title={this.props.lng.toUpperCase()} id="basic-nav-dropdown">
          <MenuItem eventKey={22.1}            
            onClick={()=>{
              i18n.changeLanguage('fr')
              Cookies.set('lang', 'fr')
            }}>
              FR
          </MenuItem>

          <MenuItem eventKey={22.2}
            onClick={() => {
              i18n.changeLanguage('en')
              Cookies.set('lang', 'en');
            }}>
              EN
          </MenuItem>

          <MenuItem eventKey={22.3}
            onClick={() => {
              i18n.changeLanguage('de')
              Cookies.set('lang', 'de');
            }}>
              DE
          </MenuItem>
        </NavDropdown>
      </Nav>
    )

    var clientInfo = user && user.client ? (
      <Nav pullRight>
        <NavItem style={{ cursor: 'default' }}>
          {t("main.client")}: <strong>{user.client}</strong>
        </NavItem>
      </Nav>
    ) : null;

    var logoutBTN = (
      <Nav pullRight>
        <NavItem eventKey={6.1} onClick={this.handleLogout} style={{ marginLeft: '10px' }}>
          <i className="fa fa-sign-out text-danger" style={{ fontSize: '16px' }} />
        </NavItem>
      </Nav>
    )


    
    var menu = [];

    // Extraire le client ID depuis params ou depuis l'URL
    var clientId = this.props.params.cid || this.props.params.id;
    if (!clientId && typeof window !== 'undefined') {
      // Parser l'URL pour les routes comme /admin/[client]/... ou /admin/[route]/[client]/...
      const pathParts = window.location.pathname.split('/');
      const adminIndex = pathParts.indexOf('admin');
      if (adminIndex > -1 && pathParts[adminIndex + 1]) {
        const routeKeywords = ['products', 'users', 'groups', 'supervision', 'supervisionErrors', 'tickets', 'clientList', 'commercialList', 'fiches', 'history', 'modules', 'addModule', 'addClient', 'importCSV', 'dashboardView', 'timelineEvents', 'LastEventsView', 'AddCommercialPage'];
        const segment1 = pathParts[adminIndex + 1];
        const segment2 = pathParts[adminIndex + 2];
        
        if (routeKeywords.includes(segment1)) {
          // URL format: /admin/[route]/[client] - le client est en position 2
          if (segment2 && !routeKeywords.includes(segment2)) {
            clientId = segment2;
          }
        } else {
          // URL format: /admin/[client]/... - le client est en position 1
          clientId = segment1;
        }
      }
    }
    
    if ((user && user.role == 'admin') && clientId) {
      var consultMenu = <ConsultMenu client={clientId} label={t('main.consultation') + ' ' + clientId} />;
    } else {
      var consultMenu = '';
    }

    var roleLabel = '';
    if (user != null && user.role) {
      if (user.role.indexOf('user') > -1) {
        var timePath = '/user/timelineEvents'
      } else if ((user.role.indexOf('client') > -1 || user.role == 'demo')) {
        var timePath = '/client/timelineEvents'
      } else if (user.role == 'admin') {
        var timePath = '/admin/' + this.props.params.cid + '/timelineEvents'
      }


      if (user && (user.role.indexOf('client') > -1 || user.role == 'demo')) {
        menu.push(
          <div>
            <Nav navbar>

              <LinkContainer to="/home">
                <NavItem eventKey={87} className="fiches-home">
                  {t("main.dashboard")}
                </NavItem>
              </LinkContainer>

              <LinkContainer to="/client/products">
                <NavItem eventKey={8.2} className="supervision-link">
                {t("main.sheets")}
                </NavItem>
              </LinkContainer>

              <LinkContainer to="/client/users">
                <NavItem eventKey={6} className="supervision-link">
                  {t("main.users")}
                </NavItem>
              </LinkContainer>


              <LinkContainer to="/client/groups">
                <NavItem eventKey={3} className="supervision-link">
                  {t("main.groups")}
                </NavItem>
              </LinkContainer>

              <LinkContainer to="/client/LastEventsView">
                <NavItem eventKey={366} className="supervision-link">
                  <span>{t("main.last_events")}</span>
                </NavItem>
              </LinkContainer>


              <NavDropdown eventKey={8} title="Modules" id="basic-nav-dropdown">
                {user.modules.indexOf('001') > -1 &&
                  <LinkContainer to={timePath}>
                    <MenuItem eventKey={8.2}>
                      Module 001
                      </MenuItem>

                  </LinkContainer>
                }
              </NavDropdown>

            </Nav>
          
          </div>
        );

      } else if (user && user.role == 'admin') {
        menu.push(
          <div>
            <Nav navbar>

              <LinkContainer to="/admin/importCSV">
                <NavItem eventKey={4.9} >
                  {t("importCSV.import_csv")}
                </NavItem>
              </LinkContainer>

              <LinkContainer to="/admin/sessions">
                <NavItem eventKey={4.3} >
                  Sessions
                </NavItem>
              </LinkContainer>

              <LinkContainer to="/admin/equipsnSync">
                <NavItem eventKey={4.4} >
                  {t("equipsnSync.title")}
                </NavItem>
              </LinkContainer>

              <NavDropdown eventKey={3} title={t("main.modules")} id="basic-nav-dropdown">
                <LinkContainer to="/admin/addModule">
                  <MenuItem eventKey={3.1}>
                    {t("modules.create_module")}
                  </MenuItem>
                </LinkContainer>

                <LinkContainer to="/admin/modules">
                  <MenuItem eventKey={3.2}>
                  {t("modules.modules_list")}
                </MenuItem>
                </LinkContainer>
              </NavDropdown>

              <NavDropdown eventKey={3} title= {t("main.clients")} id="basic-nav-dropdown">
                <LinkContainer to="/admin/addClient">
                  <MenuItem eventKey={3.1}>
                    {t("comClientForm.create_client")}
                </MenuItem>
                </LinkContainer>

                <LinkContainer to="/admin/clientList">
                  <MenuItem eventKey={3.2}>
                    {t("main.clientlist")}
                </MenuItem>
                </LinkContainer>
              </NavDropdown>

              <NavDropdown eventKey={3} title= {t("main.commercials")} id="basic-nav-dropdown">
                <LinkContainer to="/admin/addCommercialPage">
                  <MenuItem eventKey={3.1}>
                    {t("main.create_commercial")}                  
                </MenuItem>
                </LinkContainer>

                <LinkContainer to="/admin/commercialList">
                  <MenuItem eventKey={3.2}>
                    {t("main.commercials")}
                </MenuItem>
                </LinkContainer>
              </NavDropdown>

              <NavDropdown eventKey={3} title= {t("main.supervision")} id="basic-nav-dropdown">
                <LinkContainer to="/admin/supervisionErrors/dguezais">
                  <MenuItem eventKey={3.1}>
                    {t("main.anomalies")}
                </MenuItem>
                </LinkContainer>
              </NavDropdown>

            </Nav>
            
          </div>
        );
      } else if (user && user.role.indexOf('user') > -1) {
        menu.push(
          <div>
            <Nav navbar>

              <LinkContainer to="/home">
                <NavItem eventKey={87} className="fiches-home">
                  {t("main.dashboard")}
                </NavItem>
              </LinkContainer>

              <LinkContainer to="/user/fiches">
                <NavItem eventKey={7} className="fiches-link">
                  {t("main.sheets")}
                </NavItem>
              </LinkContainer>

              <LinkContainer to="/user/LastEventsView">
                <NavItem eventKey={366} className="supervision-link">
                  {t("main.last_events")}
                  </NavItem>
              </LinkContainer>

              {(user.super_user == true) &&
                <LinkContainer to="/user/groups">
                  <NavItem eventKey={3} className="supervision-link">
                    {t("main.groups")}
                  </NavItem>
                </LinkContainer>
              }

              {(user.super_user == true) &&
                [
                  <LinkContainer to="/user/users">
                    <NavItem eventKey={3} className="supervision-link">
                    {t("main.users")}
                    </NavItem>
                  </LinkContainer>,
                  <NavDropdown eventKey={8} title= {t("main.modules")} id="basic-nav-dropdown">
                    {user.modules.indexOf('001') > -1 &&
                      <LinkContainer to={timePath}>
                        <MenuItem eventKey={8.2}>
                          Module 001
                            </MenuItem>
                      </LinkContainer>
                    }
                  </NavDropdown>
                ]
              }

              {/*
              <NavItem eventKey={10}>
                <b>{user.name} connecté | Client : {user.client}</b>
              </NavItem>
              */}
            </Nav>            
          
          </div>

        );
      }
      else if (user && user.role == 'commercial') {
        menu.push(
          <div>
            <Nav navbar>

              <LinkContainer to="/commercial/clients">
                <NavItem eventKey={107} className="clients-page">
                {t("main.clients")}
                </NavItem>

              </LinkContainer>

              <LinkContainer to="/commercial/addClientCom">
                <NavItem eventKey={108} className="clients-page">
                {t("comClientForm.create_client")}
                </NavItem>
              </LinkContainer>

              {/*
              <NavDropdown eventKey={8} title="Modules" id="basic-nav-dropdown">
                <LinkContainer to={timePath}>
                  <MenuItem eventKey={8.1}>
                    Module 001
                  </MenuItem>
                </LinkContainer>
              </NavDropdown>
              */}

            </Nav>
           
          </div>
        );

      }

    } else {
      menu.push(
        <div>
          <Nav navbar>
            <LinkContainer to="/login">
              <NavItem eventKey={6} className="login-link" onClick={this.handleLogin}>
                {t("login.login")}
              </NavItem>
            </LinkContainer>
          </Nav>
        </div>
      );
    }

    var topMenuStyle = {
      /*position: 'absolute',
      right: '0px',
      top: '0px',
      zIndex: 999999,*/
      background: 'none',
      border: 'none',
      
    }

    if (!config.isProduction) {
      //topMenuStyle.background = '#ffe9e9';
      /*topMenuStyle['border-top'] = '2px solid #ff7f3a';
      topMenuStyle['border-bottom'] = '2px solid #ff7f3a';*/
    }

    var suffix = null

    if (user) {

      if (config.isProduction) {
        if (user.role == 'demo') {
          suffix = "DEMO"
        }

        if (user.role == 'userReadOnly' || user.role == 'clientReadOnly') {
          suffix = t("main.restricted_mode")
        }
      } else {

        suffix = ""

        if (user.role == 'demo') {
          suffix += " DEMO"
        }

        if (user.role == 'userReadOnly' || user.role == 'clientReadOnly') {
          suffix = t("main.restricted_mode")
        }

      }
    }

    return (

      <div className={styles.app}>

        <Helmet {...config.app.head} />

        <div className='menu-container'>
          <PortalMenu/>
          
          <div className="topMenu" style={topMenuStyle}>
            <Navbar fixedTop={false} collapseOnSelect={true} style={{borderTop:'2px solid rgb(28 42 104)', paddingTop:'10px'}}>
              <Navbar.Header>
                <Navbar.Brand>
                  <NavLink to="/" exact activeStyle={{ color: '#33e0ff' }}>

                    <div style={{
                      display: 'flex',
                      alignItems: 'center', // Alignement vertical
                      justifyContent: 'left', // Alignement horizontal
                      height: '100%', // Assurez-vous que le div prend toute la hauteur du Card.Body
                      fontFamily: 'upcli',
                      cursor:'pointer'
                    }} onClick={() => {}}>
                        <img src={logo} style={{ marginRight: '0px', width: '168px', paddingTop:'0px' }} alt="@" />
                    </div>
                    
                  </NavLink>
                </Navbar.Brand>

                <Navbar.Toggle />
                {isSmallScreen &&
                  <div style={{ float: 'right', marginRight:'10px' }}>{langChooser}</div>
                }
                
              </Navbar.Header>


              <Navbar.Collapse eventKey={0}>
                {menu}

                {roleLabel}

                {logoutBTN}

                <Nav pullRight>
                  <NavItem style={{width:'100px', margin:'0 auto'}} >
                    <Notice/>
                  </NavItem>
                
                  <NavItem style={{margin:'0 auto', width:'100px' }}>
                    <Label bsStyle="primary" style={{
                      display: 'block',
                      padding: '5px',
                      background: "#6f96b7",
                      fontSize: '14px',
                      width: '87px',
                      height: '26px',
                    }}>
                      <b><i>Version 2.0 </i></b>               
                    </Label>
                  </NavItem>                  
                </Nav>

                {clientInfo}

                { ! isSmallScreen && langChooser}
              
              </Navbar.Collapse>

            </Navbar>
          </div>
        </div>


        <div className={styles.appContent}>
          <div className="container">
            {user && (user.role == 'demo') &&
              <div className="returnLink">
                <a style={{
                  color: 'white'
                }} href="https://produits.amphitech.fr" target="_blank"><b>{t("comClientForm.create_client")}Retour sur le site amphitech.fr</b></a>
              </div>
            }
            <div style={{ marginTop: '10px' }}>
              {user && (user.role == 'admin') &&

                <div className="app-role-bar" style={{ zIndex: 100000000/*, marginTop:'5px'*//*, position: 'fixed' */}}>

                  <div style={{ float: "left" }}>
                    <Button bsStyle="danger" bsSize="sm" style={{
                      height: '33px', fontSize: "16px",
                      borderRadius: '5px', lineHeight: '0px'
                    }}>
                      
                      <b>
                        <i>{t("main.administration")}</i>
                      </b>
                    </Button>
                  </div>

                  <div style={{ float: "left", marginLeft: '9px' }}> 
                    {consultMenu}
                  </div>

                  <div style={{ float: "left", marginLeft: '15px' }}>
                    {this.props.loadingBar > 0 && <i style={{fontSize:'22px'}} className={'fa fa-spinner fa-spin'}/>}
                  </div>

                </div>

              }

  
              {user && user.role && (user.role.indexOf('user') > -1 && user.super_user == 1) &&
                <div className="app-role-bar" style={{ zIndex: 10000, marginTop: '15px' }}>
                  <div style={{ float: "left" }}>
                    <Button bsStyle="danger" bsSize="sm" style={{ height: '25px', fontSize: "16px", borderRadius: '5px', lineHeight: '0px' }}>
                      {user.supervisor == 1 && <b><i>{t("main.client")}</i></b>}
                      {user.supervisor == 0 && <b><i>{t("main.super_user")}</i></b>}
                    </Button>
                  </div>

                  <div style={{ float: "left", marginLeft: '9px' }}>
                    {consultMenu}
                  </div>
                </div>
              }

              {user && (user.role == 'commercial') &&
                <div className="app-role-bar" style={{ zIndex: 10000/*, marginTop:'5px'*/ }}>
                  <div style={{ float: "left" }}>
                    <Button bsStyle="danger" bsSize="sm" style={{ height: '33px', fontSize: "18px", borderRadius: '0px 0px 5px 5px', lineHeight: '0px' }}><b><i>{t("main.commercial")}</i></b></Button>
                  </div>
                </div>
              }
            </div>
          </div>

          <div className="app-main" style={{ margin: '25px 0 0', paddingBottom: '70px' }}>
            {this.props.children}
          </div>

        </div>

        <Footer/>
      </div>

    );
  }
}

